import React from "react";

function OfflineEstimation() {
  return <div>OfflineEstimation</div>;
}

export default OfflineEstimation;
